import React from 'react'
import Dots from '../../components/Dots'
import Navbar from '../../components/Navbar'
import arrow from '../../assets/arrow.png'
import plants from '../../assets/plants.png'
import plants2 from '../../assets/plants2.png'
import leaf from '../../assets/leaf.png'
import leaf2 from '../../assets/leaf2.png'
import tree from '../../assets/trees.png'
import cactus from '../../assets/cactus.jpg'
import { FaShippingFast } from 'react-icons/fa'
import { GiMoneyStack, GiFlowerPot, GiBrain } from 'react-icons/gi'
import { AiOutlineFieldTime } from 'react-icons/ai'
import { RiMentalHealthLine } from 'react-icons/ri'
import { BiRun } from 'react-icons/bi'
import Footer from '../../components/Footer'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Link } from 'react-router-dom'


const Reviews = [{
    name: "Shivam Sharma",
    desg: "Accountant, Hyderabad",
    image: "https://thedrivemagazine.com/wp-content/uploads/sites/46/2020/12/Yash_.jpg",
    review: "During the lockdown period Go Green has been really helpful for ordering and getting doorstep delivery of plants and gardening products.",
    star: 4
},
{
    name: "Rashmi Trivedi",
    desg: "Chef, Delhi",
    image: "https://cloudfront.penguin.co.in/wp-content/uploads/2018/06/Indian-Instincts_Header-scaled.jpg",
    review: "The easy to use interface and the variety of products available on Go Green is just astonishing I wasn't even aware of the nurseries in my area and now I can access any of them with the comfort of sitting at home and get these products delivered to me. Thankyou Go Green.",
    star: 5
},
{
    name: "Javed Ahemed Khan",
    desg: "Nursery Owner, Pryagraj",
    image: "https://st.depositphotos.com/1093689/1373/i/600/depositphotos_13736150-stock-photo-close-up-image-of-happy.jpg",
    review: "I own multiple nursery all over Allahabad and in these tough times of corona we were having a lot of trouble staying in the market and surviving this pandemic but Go Green provided us with a really usefull platform as well as logistic help for providing to our customers. We are really thankful to the Go Green team for such a initiative.",
    star: 5
}]

const Landing = () => {
    return (
        <div className='font-poppins overflow-x-hidden'>
            <div className=' bg-[#F8FBF8] dark:bg-black'>
                <Navbar />
                <div className='mt-16'>
                    <Dots />
                </div>

                <div className='flex pb-5 flex-col md:flex-row justify-center items-center mt-2'>
                    <div className='flex flex-col space-y-10 md:w-1/2 justify-center lg:pl-36'>
                        <div className='text-2xl md:text-3xl font-bold ml-10 lg:text-5xl  leading-tight'>A beautiful plant is like having a friend around the house.</div>
                        <div className='mx-10 text-justify text-sm lg:text-base md:w-10/12'>Having plants in our homes or in our offices doesn’t just look good, it also boosts our mood, makes us more productive, and cleans the air around us by absorbing toxins

                            Most of us being urban dwellers spending their days in apartments with limited access to parks and ecological reserves, have no way of feeling close to nature and experiencing the benefits of being around plants.
                            <br></br>
                            Ordering a pizza is easy but ever heard of ordering a plant to your doorstep? This is where Go-Green comes in.</div>
                        <div className='flex space-x-10 mx-auto md:mx-8'>
                            <div className='p-1 md:p-2 lg:p-3 bg-green-500 font-bold text-xl rounded-3xl text-center text-white w-52 '><Link to='/shop' >Explore More</Link></div>
                        </div>
                    </div>
                    <img src={arrow} alt="arrow" className="hidden lg:block absolute h-12 w-12 -rotate-90 bottom-60 " />
                    <div className='flex-none md:w-1/2 justify-center items-center relative flex'>
                        <LazyLoadImage
                            alt="ecommerce"
                            effect="blur"
                            className="mx-auto w-full scale-75 md:scale-100 "
                            src={plants} // use normal <img> attributes as props
                        />
                    </div>
                    <div className='hidden lg:block absolute right-0 bottom-0' ><Dots /><Dots /></div>
                </div>
            </div>

            <div className='py-8 dark:bg-black flex flex-col md:flex-row justify-center items-center'>
                <div className=' relative md:w-1/2 justify-center items-center flex order-last md:order-none mt-3'>
                    <img alt="ecommerce" src={plants2} className="flex-none relative " />
                    <div className='hidden lg:block absolute left-0 bottom-0' ><Dots /><span className='rotate-45 left-0'><Dots /></span>  </div>
                </div>
                <div className='flex flex-col md:flex-row md:w-1/2 justify-center items-center relative'>
                    <img src={leaf} alt="leaf" className='hidden lg:block absolute w-48 h-48 animate-pulse delay-100 ease-in-out right-0 top-0' />
                    <div className='flex flex-col space-y-5 md:space-y-10 justify-center  lg:pr-32'>
                        <div className='w-full ml-8 md:ml-0'>
                            <div className='text-green-500 text-base md:text-xl lg:text-2xl'>#Why Us</div>
                            <div className='text-2xl md:text-4xl font-bold lg:text-5xl  leading-tight'>Best For Your Home</div>
                        </div>
                        <div className='mx-8 md:mx-0 text-sm md:text-base md:w-10/12'>We believe that Green is Good and are here to enable Indians to access plants in the easiest way possible – online! We are here to shape the future of gardening!

                            A one-stop-shop for all gardening related requirements, Go-Green has more than 6000 products available online for delivery across India saving you numerous messy trips to various nurseries.</div>
                        <div className='flex flex-row space-x-5 lg:space-x-24 text-6xl text-green-600 mx-auto md:mx-0 items-center justify-center'>
                            <div>
                                <div className='bg-green-200 scale-75 md:scale-100 h-20 w-20 items-center flex justify-center rounded-full'><FaShippingFast /></div>
                                <span className='text-sm md:text-base font-bold'>Fast Shipping</span>
                            </div>
                            <div>
                                <div className='bg-green-200 scale-75 md:scale-100 h-20 w-20 items-center flex justify-center rounded-full'><GiMoneyStack /></div>
                                <span className='text-sm md:text-base font-bold'>Value For Money</span>
                            </div>
                            <div>
                                <div className='bg-green-200 scale-75 md:scale-100 h-20 w-20 items-center flex justify-center rounded-full'><AiOutlineFieldTime /></div>
                                <span className='text-sm md:text-base font-bold'>24x7 Support</span>
                            </div>
                        </div>
                        <div className='flex space-x-10 lg:space-x-40 mx-auto md:mx-0'>
                            <div className='relative flex flex-col space-y-2 md:space-y-12'>
                                <div className='text-lg text-green-600'>Starting with Just ₹ 99</div>
                                <div className='p-1 md:p-2 lg:p-3 cursor-pointer bg-green-500 font-bold text-base md:text-xl rounded-3xl text-center text-white md:w-52'><Link to="/shop" >Shop Now</Link></div>
                            </div>
                            <img src={cactus} alt="cactus" className='dark:hidden object-cover h-24 w-12 md:h-40 md:w-20 rotate-12' />
                            <img src={arrow} alt="arrow" className="hidden dark:hidden lg:block absolute h-16 w-16 rotate-90 left-24 bottom-10" />
                        </div>
                    </div>

                </div>
            </div>

            <div className=' bg-[#F8FBF8] dark:bg-black dark:text-white relative py-8'>
                <img src={tree} alt="tree" className='hidden lg:block scale-50 absolute z-30 opacity-20 -top-10' />
                <div className='relative z-40 space-y-20'>
                    <div className='text-2xl md:text-3xl lg:text-5xl text-center leading-snug lg:pt-32 font-bold shadow-sm'>The Advantage of Having <span className='text-green-600'>Plants</span><br /> in Your Home</div>
                    <div className='flex flex-col md:flex-row md:space-x-12 lg:space-x-32 space-y-10 justify-center items-center text-center'>
                        <div className='space-y-8 md:space-y-10 flex flex-col justify-center items-center'>
                            <div className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40 shadow-md shadow-green-400 bg-green-500 text-white rounded-full items-center justify-center flex'><RiMentalHealthLine className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40' />
                            </div>
                            <span className='text-sm md:text-xl font-semiboldbold'>Reduce stress <br />and fatigue</span> </div>
                        <div className='space-y-8 md:space-y-10 flex flex-col justify-center items-center'>
                            <div className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40 shadow-md shadow-green-400 bg-green-500 text-white rounded-full items-center justify-center flex'><GiFlowerPot className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40' />
                            </div>
                            <span className='text-sm md:text-xl font-semiboldbold'>Clear indoor air by <br />absorbing toxins</span> </div>
                        <div className='space-y-8 md:space-y-10 flex flex-col justify-center items-center'>
                            <div className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40 shadow-md shadow-green-400 bg-green-500 text-white rounded-full items-center justify-center flex'><GiBrain className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40' />
                            </div>
                            <span className='text-sm md:text-xl font-semiboldbold'>Boost your <br />productivity</span> </div>
                        <div className='space-y-8 md:space-y-10 flex flex-col justify-center items-center'>
                            <div className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40 shadow-md shadow-green-400 bg-green-500 text-white rounded-full items-center justify-center flex'><BiRun className='h-20 w-20 md:w-32 md:h-32 lg:h-40 lg:w-40' /></div>
                            <span className='text-sm md:text-xl font-semiboldbold'>Faster recover <br />from illness</span> </div>
                    </div>
                </div>
                <img src={leaf2} alt="leaf2" className='hidden lg:block absolute -rotate-[30deg] h-60 w-320 text-green-700 right-0 top-0' />
            </div>

            <div className="overflow-hidden dark:bg-none dark:bg-black lg:bg-[url('/public/assets/grass.jpg')] lg:bg-cover bg-opacity-30">
                <div >
                    <div className="mx-auto  px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="text-4xl font-bold tracking-tight sm:text-5xl">
                                Read trusted reviews from our customers
                            </h2>

                            <p className="text-gring-offset-warm-green-500 mx-auto mt-4 max-w-lg">
                                When choosing online shopping sites, you want the best.
                                What better proof than seeing what customers have to say.
                                We constantly survey our customers and ask if they’re willing to say a few words.
                                As you’ll see, many do. We’re proud of our high quality products and services,
                                and most proud of the value we’ve delivered to these clients.
                            </p>
                        </div>

                        <div
                            className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-16 lg:grid-cols-3"
                        >

                            {
                                Reviews.map((review) => (
                                    <div key={review.name} className='shadow-xl mt-3 sm:mt-0 dark:shadow-lg rounded-xl dark:shadow-green-400'>
                                        <img
                                            alt="Woman"
                                            src={review.image}
                                            className="mt-2 mx-auto h-24 w-24 rounded-full object-cover shadow-xl"
                                        />

                                        <blockquote
                                            className="-mt-6 flex flex-col justify-between rounded-lg p-12 text-center "
                                        >
                                            <p className="text-lg font-bold text-green-700">{review.name}</p>
                                            <p className="mt-1 text-xs font-medium text-green-500">
                                                {review.desg}
                                            </p>
                                            <p className="mt-4 text-sm text-green-500">
                                                {review.review}
                                            </p>

                                            <div className="mt-8 flex justify-center gap-0.5 text-green-500">
                                                {
                                                    Array(review.star).fill().map((_, i) => (
                                                        <svg key={i}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="h-6 w-6"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                                            />
                                                        </svg>
                                                    ))

                                                }

                                            </div>
                                        </blockquote>
                                    </div>

                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>


            <Footer />
        </div>
    )
}

export default Landing
